import { Set } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { HexaDirection } from '../../jscaip/HexaDirection';
import { AbaloneMove } from './AbaloneMove';
import { AbaloneRules } from './AbaloneRules';
import { AbaloneState } from './AbaloneState';
export class AbaloneMoveGenerator extends MoveGenerator {
    getListMoves(node, config) {
        const moves = [];
        const state = node.gameState;
        const player = state.getCurrentPlayer();
        for (const coordAndContent of state.getCoordsAndContents()) {
            const first = coordAndContent.coord;
            if (state.getPieceAt(first).is(player) === false) {
                continue;
            }
            for (const dir of HexaDirection.factory.all) {
                const move = AbaloneMove.ofSingleCoord(first, dir);
                if (this.isAcceptablePush(move, state, config)) {
                    moves.push(move);
                }
                else {
                    continue;
                }
                for (const alignment of HexaDirection.factory.all) {
                    for (let distance = 1; distance <= 2; distance++) {
                        if (alignment.equals(dir)) {
                            break;
                        }
                        const second = first.getNext(alignment, distance);
                        if (state.isOnBoard(second)) {
                            const translation = AbaloneMove.ofDoubleCoord(first, second, dir);
                            if (AbaloneRules.get().isLegal(translation, state, config).isSuccess()) {
                                moves.push(translation);
                            }
                        }
                        else {
                            break;
                        }
                    }
                }
            }
        }
        return new Set(moves).toList();
    }
    isAcceptablePush(move, state, config) {
        const scores = state.getScores();
        const status = AbaloneRules.get().isLegal(move, state, config);
        if (status.isSuccess()) {
            const opponent = state.getCurrentOpponent();
            const newState = new AbaloneState(status.get(), state.turn + 1);
            const newScores = newState.getScores();
            if (scores.get(opponent) < newScores.get(opponent)) {
                return false; // some player just push themself
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
}
